export const APP_NAME = 'NoPanel';
export const APP_DESCRIPTION = 'Self-hosted server & deployment console';

export const STALE_TIMES = {
  repos: 3 * 60 * 1000,
  secrets: 2 * 60 * 1000,
  variables: 2 * 60 * 1000,
  workflows: 10 * 60 * 1000,
  servers: 30 * 1000,
  projects: 60 * 1000,
  teams: 2 * 60 * 1000,
  deployments: 10 * 1000,
  environments: 30 * 1000,
  notifications: 15 * 1000,
  deploymentTemplates: 5 * 60 * 1000,
  gitCommits: 30 * 1000,
  gitBranches: 60 * 1000,
  gitTree: 60 * 1000,
  gitBlob: 2 * 60 * 1000,
  cloudflareToken: 120_000,
  cloudflareZones: 60_000,
  cloudflareDns: 30_000,
  cloudflarePages: 30_000,
  cloudflareWorkers: 60_000,
  webhooks: 30_000,
  webhookDeliveries: 10_000,
  variableGroups: 30_000,
  pipelines: 30_000,
  pipelineRuns: 10_000,
  workflowRuns: 30 * 1000,
  workflowJobs: 10 * 1000,
} as const;

export const GC_TIMES = {
  repos: 30 * 60 * 1000,
  secrets: 10 * 60 * 1000,
  variables: 10 * 60 * 1000,
  workflows: 60 * 60 * 1000,
  servers: 10 * 60 * 1000,
  projects: 10 * 60 * 1000,
  teams: 30 * 60 * 1000,
  deployments: 5 * 60 * 1000,
  environments: 10 * 60 * 1000,
  notifications: 5 * 60 * 1000,
  deploymentTemplates: 30 * 60 * 1000,
  gitCommits: 5 * 60 * 1000,
  gitBranches: 10 * 60 * 1000,
  gitTree: 10 * 60 * 1000,
  gitBlob: 15 * 60 * 1000,
  cloudflare: 5 * 60_000,
  webhooks: 5 * 60_000,
  webhookDeliveries: 5 * 60_000,
  variableGroups: 10 * 60_000,
  pipelines: 10 * 60_000,
  pipelineRuns: 5 * 60_000,
  workflowRuns: 5 * 60 * 1000,
  workflowJobs: 5 * 60 * 1000,
} as const;

export const MAX_RECENT_REPOS = 20;
export const SEARCH_DEBOUNCE_MS = 300;
export const VIRTUAL_LIST_OVERSCAN = 10;

/**
 * Threshold for conditionally enabling virtualization in list views.
 * When item count exceeds this, consumers should pass `virtual` config to
 * <EntityListView> (or use @tanstack/react-virtual) to avoid DOM bloat.
 */
export const VIRTUAL_LIST_THRESHOLD = 50;

/**
 * StaleTime / gcTime strategy (refined for perf):
 * - Short for realtime/frequent mutate (servers 30s, deployments 10s, pipelineRuns 10s)
 * - Medium for interactive (projects 60s, secrets 2m)
 * - Long for mostly static (workflows 10m, teams 2m, repos 3m)
 * keepPreviousData used on list queries for filter stability (no flash on param change).
 */
